module.exports = __webpack_public_path__ + "img/third_fr.5c392d18.jpg";